import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { QUESTION_PALETTE } from "../../../utils/surveysConstants";

// Left column of the builder — click a component to append it to the survey.
// An explicit collapsible panel (rather than a plain scrolling block) so on
// narrow screens, where this stacks above the form, it's obvious it can be
// closed out of the way after picking components instead of always eating
// screen space.
const SurveyComponentPalette = ({ onAdd }) => {
  return (
    <Accordion className="survey-builder_palette" defaultExpanded disableGutters elevation={0} square>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <h4>Survey Components</h4>
      </AccordionSummary>
      <AccordionDetails>
        <p className="survey-builder_palette_hint">Click a component to add it to the survey.</p>
        <div className="survey-builder_palette_list">
          {QUESTION_PALETTE.map((item) => (
            <button key={item.key} type="button" className="survey-builder_palette_item" onClick={() => onAdd(item)}>
              <span className="survey-builder_palette_item_label">+ {item.label}</span>
              <span className="survey-builder_palette_item_desc">{item.description}</span>
            </button>
          ))}
        </div>
      </AccordionDetails>
    </Accordion>
  );
};

export default SurveyComponentPalette;
